import { useActorRef } from '@xstate5/react';

import { bundleMachine } from './bundle.machine';

import type { MachineImplementationsFrom } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Initializes and provides a reference to a bundle state machine actor.
 */
export const useInitBundleMachine = (implementations?: Implementations) => {
  return useActorRef(bundleMachine.provide({ ...implementations }), { input: {} });
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Implementations = MachineImplementationsFrom<typeof bundleMachine>;
